import { render, staticRenderFns } from "./unmanaged.vue?vue&type=template&id=647c2de8&scoped=true"
import script from "./unmanaged.vue?vue&type=script&lang=js"
export * from "./unmanaged.vue?vue&type=script&lang=js"
import style0 from "./unmanaged.vue?vue&type=style&index=0&id=647c2de8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c2de8",
  null
  
)

export default component.exports